webpackJsonp([43369700788870],{

/***/ 332:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _submissionRequestHandler = __webpack_require__(161);
	
	var _submissionRequestHandler2 = _interopRequireDefault(_submissionRequestHandler);
	
	var _formValidator = __webpack_require__(47);
	
	var _inputStage = __webpack_require__(333);
	
	var _inputStage2 = _interopRequireDefault(_inputStage);
	
	var _submittingStage = __webpack_require__(336);
	
	var _submittingStage2 = _interopRequireDefault(_submittingStage);
	
	var _submissionFailedStage = __webpack_require__(334);
	
	var _submissionFailedStage2 = _interopRequireDefault(_submissionFailedStage);
	
	var _submissionSuccessfulStage = __webpack_require__(335);
	
	var _submissionSuccessfulStage2 = _interopRequireDefault(_submissionSuccessfulStage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var fields = ['emailValue', 'messageValue'];
	
	var a = function a(action, label) {
	  return ga('send', {
	    hitType: 'event',
	    eventCategory: 'ContactForm',
	    eventAction: action,
	    eventLabel: label
	  });
	};
	
	var ContactForm = function (_Component) {
	  _inherits(ContactForm, _Component);
	
	  function ContactForm(props) {
	    _classCallCheck(this, ContactForm);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.onChange = function (property, value) {
	      _this.setState(function () {
	        var _ref;
	
	        return _ref = {}, _ref[property] = value, _ref;
	      });
	      _this.setState(function (state) {
	        return {
	          formValid: (0, _formValidator.validateFields)(fields, state),
	          formValidationMessage: (0, _formValidator.getValidationMessage)(fields, state)
	        };
	      });
	    };
	
	    _this.submit = function () {
	      a('SubmitForm');
	      var _this$state = _this.state,
	          emailValue = _this$state.emailValue,
	          messageValue = _this$state.messageValue;
	
	
	      _this.setState({
	        submitting: true
	      });
	
	      (0, _submissionRequestHandler2.default)('contact', null, {
	        fields: {
	          itemId: '__CONTACT_US_FORM__',
	          email: emailValue,
	          info: messageValue
	        }
	      }).then(function (result) {
	        if (result === true) {
	          a('SubmissionSuccessful');
	        } else {
	          a('SubmissionFailed');
	        }
	
	        _this.setState({
	          submitting: false,
	          submitted: true,
	          submissionSuccessful: result === true
	        });
	      });
	    };
	
	    _this.backToForm = function () {
	      a('BackToInput', _this.props.form);
	      _this.setState({
	        submitted: false,
	        submissionSuccessful: null
	      });
	    };
	
	    _this.state = {
	      emailValue: '',
	      messageValue: '',
	
	      formValid: false,
	      formValidationMessage: (0, _formValidator.getValidationMessage)(fields, {}),
	
	      submitting: false,
	      submitted: false,
	      submissionSuccessful: null
	    };
	
	    a('OpenForm');
	    return _this;
	  }
	
	  ContactForm.prototype.render = function render() {
	    var Stage = _inputStage2.default;
	
	    var _state = this.state,
	        emailValue = _state.emailValue,
	        messageValue = _state.messageValue,
	        formValid = _state.formValid,
	        formValidationMessage = _state.formValidationMessage,
	        submitting = _state.submitting,
	        submitted = _state.submitted,
	        submissionSuccessful = _state.submissionSuccessful;
	
	
	    if (submitting) {
	      Stage = _submittingStage2.default;
	    } else if (submitted && submissionSuccessful) {
	      Stage = _submissionSuccessfulStage2.default;
	    } else if (submitted && !submissionSuccessful) {
	      Stage = _submissionFailedStage2.default;
	    }
	
	    return _react2.default.createElement(Stage, {
	      emailValue: emailValue,
	      messageValue: messageValue,
	      onChange: this.onChange,
	      formValid: formValid,
	      formValidationMessage: formValidationMessage,
	      submit: this.submit,
	      backToForm: this.backToForm,
	      submissionSuccessful: submissionSuccessful
	    });
	  };
	
	  return ContactForm;
	}(_react.Component);
	
	exports.default = ContactForm;
	module.exports = exports['default'];

/***/ }),

/***/ 333:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(11);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _stylesModule = __webpack_require__(638);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	var _text = __webpack_require__(4);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _textBox = __webpack_require__(13);
	
	var _textBox2 = _interopRequireDefault(_textBox);
	
	var _textArea = __webpack_require__(27);
	
	var _textArea2 = _interopRequireDefault(_textArea);
	
	var _emailNotice = __webpack_require__(160);
	
	var _emailNotice2 = _interopRequireDefault(_emailNotice);
	
	var _pillButton = __webpack_require__(8);
	
	var _pillButton2 = _interopRequireDefault(_pillButton);
	
	var _Tooltip = __webpack_require__(60);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var emailValue = _ref.emailValue,
	      messageValue = _ref.messageValue,
	      _onChange = _ref.onChange,
	      formValid = _ref.formValid,
	      formValidationMessage = _ref.formValidationMessage,
	      submit = _ref.submit;
	
	  var submitButton = _react2.default.createElement(_pillButton2.default, {
	    type: 'submit',
	    preventDefault: true,
	    text: 'Submit',
	    onClick: submit,
	    disabled: !formValid
	  });
	
	  return _react2.default.createElement(
	    'div',
	    { className: _stylesModule2.default.container },
	    _react2.default.createElement(
	      'p',
	      null,
	      'If you have any questions, comments or suggestions related to the website feel free to contact us using the form below. Please provide a valid email address so that we can get back to you if we need to.'
	    ),
	    _react2.default.createElement(_textBox2.default, {
	      type: 'email',
	      id: _text2.default.FORMS.emailId,
	      label: _text2.default.FORMS.emailLabel,
	      placeholder: _text2.default.FORMS.emailPlaceholder,
	      value: emailValue,
	      onChange: function onChange(event) {
	        return _onChange('emailValue', event.target.value);
	      }
	    }),
	    _react2.default.createElement(_emailNotice2.default, null),
	    _react2.default.createElement(_textArea2.default, {
	      id: 'message',
	      label: 'Your Message',
	      placeholder: 'Enter your message...',
	      value: messageValue,
	      onChange: function onChange(event) {
	        return _onChange('messageValue', event.target.value);
	      }
	    }),
	    !formValid ? _react2.default.createElement(
	      _Tooltip2.default,
	      { text: formValidationMessage },
	      submitButton
	    ) : submitButton
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 638:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"src-page-components-contact-us-contact-form-input-stage----styles-module---container---pdQYX"};

/***/ }),

/***/ 334:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _stylesModule = __webpack_require__(639);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	var _pillButton = __webpack_require__(8);
	
	var _pillButton2 = _interopRequireDefault(_pillButton);
	
	var _Cross = __webpack_require__(28);
	
	var _Cross2 = _interopRequireDefault(_Cross);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var backToForm = _ref.backToForm,
	      submit = _ref.submit;
	  return _react2.default.createElement(
	    'div',
	    { className: _stylesModule2.default.container },
	    _react2.default.createElement(_Cross2.default, { size: 96, color: '#AD343E' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Failed to send submission'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'There may be an issue with our system. Please try again later.'
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _stylesModule2.default.buttons },
	      _react2.default.createElement(_pillButton2.default, { theme: 'grey-ghost', text: 'Back', onClick: backToForm }),
	      _react2.default.createElement(_pillButton2.default, { theme: 'blue', text: 'Retry', onClick: submit })
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 639:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"src-page-components-contact-us-contact-form-submission-failed-stage----styles-module---container---NpYrs","buttons":"src-page-components-contact-us-contact-form-submission-failed-stage----styles-module---buttons---1Lcf3"};

/***/ }),

/***/ 335:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _stylesModule = __webpack_require__(640);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	var _Tick = __webpack_require__(62);
	
	var _Tick2 = _interopRequireDefault(_Tick);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  return _react2.default.createElement(
	    'div',
	    { className: _stylesModule2.default.container },
	    _react2.default.createElement(_Tick2.default, { size: 96, color: '#56ad65' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Your submission was successful'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'We will review your submission and reply if required.'
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 640:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"src-page-components-contact-us-contact-form-submission-successful-stage----styles-module---container---1nXCU"};

/***/ }),

/***/ 336:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _stylesModule = __webpack_require__(641);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	var _loadingIndicator = __webpack_require__(162);
	
	var _loadingIndicator2 = _interopRequireDefault(_loadingIndicator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var closeForm = _ref.closeForm,
	      secondaryButtonIsBack = _ref.secondaryButtonIsBack,
	      clearForm = _ref.clearForm;
	  return _react2.default.createElement(
	    'div',
	    { className: _stylesModule2.default.container },
	    _react2.default.createElement(_loadingIndicator2.default, null),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Sending your submission'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Please wait...'
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 641:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"src-page-components-contact-us-contact-form-submitting-stage----styles-module---container---ABEuD"};

/***/ }),

/***/ 337:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(11);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(32);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _stylesModule = __webpack_require__(642);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	var _backgroundContainer = __webpack_require__(33);
	
	var _backgroundContainer2 = _interopRequireDefault(_backgroundContainer);
	
	var _gridWrap = __webpack_require__(34);
	
	var _gridWrap2 = _interopRequireDefault(_gridWrap);
	
	var _siteFooter = __webpack_require__(42);
	
	var _siteFooter2 = _interopRequireDefault(_siteFooter);
	
	var _room = __webpack_require__(46);
	
	var _room2 = _interopRequireDefault(_room);
	
	var _contactForm = __webpack_require__(332);
	
	var _contactForm2 = _interopRequireDefault(_contactForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_reactHelmet2.default, { title: 'Contact Us' }),
	    _react2.default.createElement(
	      _backgroundContainer2.default,
	      { src: _room2.default },
	      _react2.default.createElement(
	        'div',
	        { className: _stylesModule2.default.top },
	        _react2.default.createElement(
	          _gridWrap2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: _stylesModule2.default.topContent },
	            _react2.default.createElement(
	              'h1',
	              null,
	              'Contact Us'
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _gridWrap2.default,
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: _stylesModule2.default.content },
	        _react2.default.createElement(_contactForm2.default, null)
	      )
	    ),
	    _react2.default.createElement(_siteFooter2.default, null)
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 642:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"topContent":"src-page-components-contact-us----styles-module---topContent---2R-yx","content":"src-page-components-contact-us----styles-module---content---3uMOk"};

/***/ }),

/***/ 357:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _contactUs = __webpack_require__(337);
	
	var _contactUs2 = _interopRequireDefault(_contactUs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _contactUs2.default;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-contact-us-js-31f16895b59321e0017c.js